import clsx from "clsx";

import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
}

const AttributionCellFormatter = <TData,>(props: TableCellProps<TData>) => {
  return (
    <div
      className={clsx(
        "px-4 py-2.5 bg-inherit font-mono h-full",
        "text-sm text-v2-action font-medium tracking-[0.28px]",
        "flex justify-center items-center",
      )}
      title={String(props.cell.getValue())}
    >
      {String(props.cell.getValue()).toUpperCase() === "YES" && (
        <i className="fa-light fa-circle-check text-v2-action-positive-default"></i>
      )}
    </div>
  );
};

export default AttributionCellFormatter;
